<template>
	<div class="page-content qualityManual">
		<!-- 面包屑导航 -->
		<!-- <Breadcrumb /> -->
		<!-- ppt  -->
		<div class="qualityManual-container" v-if="option.url">
			<div class="qualityManual-container-office">
				<vab-only-office :option="option" />
			</div>
		</div>
		<!-- mp4 -->
		<div class="video-player" v-if="fileUrl && this.queryParams.type=='mp4'">
			<!-- 使用video标签播放视频 -->
			<video controls>
				<!-- 指定视频文件的URL -->
				<source :src="fileUrl" type="video/mp4">
				您的浏览器不支持HTML5 video标签。
			</video>
		</div>
		<!-- 图片 -->
		<div class="video-player" v-if="fileUrl && (this.queryParams.type=='jpg' || this.queryParams.type=='jpeg' || this.queryParams.type=='png' || this.queryParams.type=='gif')">
			<img :src="fileUrl"/>
		</div>
	</div>
</template>

<script>
	import vabOnlyOffice from "@/components/vanOnkyOffice";
	import domain from '../../../config/app.js'
	// import Breadcrumb from '@/components/Breadcrumb.vue'
	export default {
		name: "QualityManual",
		components: {
			vabOnlyOffice,
			// Breadcrumb
		},

		data() {
			return {
				queryParams: {}, //地址栏参数
				fileUrl: '',
				//参考vabOnlyOffice组件参数配置
				option: {
					url: "",
					isEdit: "",
					fileType: "",
					title: "",
					lang: "",
					isPrint: "",
				},
				randomString: '',
			};
		},
		methods: {
			generateRandomString() {
				const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
				let result = '';
				for (let i = 0; i < 12; i++) {
					result += letters.charAt(Math.floor(Math.random() * letters.length));
				}
				this.randomString = result;
			},
		},
		mounted() {
			this.generateRandomString(); // 组件挂载时生成一次随机字符串
			var meta = this.$route.query;
			this.queryParams = meta;
			console.log('预览urls',meta.url)
			if (meta.type == 'mp4' || meta.type == 'jpg' || meta.type == 'jpeg' || meta.type == 'png' || meta.type == 'gif') {
				this.fileUrl = meta.class==2?meta.url:domain.urls+'/api/profile/'+meta.url
			} else if (meta.type == 'ppt' || meta.type == 'pptx' || meta.type == 'docx' || meta.type == 'doc' || meta
				.type == 'xlsx' || meta.type == 'xls' || meta.type == 'pdf') {
					console.log('------')
				this.option = {
					isEdit:false, 
					lang: 'zh-CN',
					url: meta.class==2?meta.url:'https://onlyoffice.ai.1andx.com/api/profile/'+meta.url,
					title: meta.name,
					fileType: meta.type,
					isPrint: false,
					//editUrl:domain+"ed_resources/reUpload?uploadPath="+encodeURIComponent(meta.uploadPath),
					key: meta.randomString
				}
			}
		},
	};
</script>

<style scoped>
	.qualityManual{
		max-width: 1400px;
		margin: 80px auto 50px;
		padding:  40px;
	}

	.qualityManual-container-office {
		width: 100%;
		height: 80vh;
	}
	.video-player{
		text-align: center;
	}
	.video-player video{
		width: 100%;
		height: 80vh;
	}
	.video-player img{
		max-width: 100%;
	}
</style>